// extracted by mini-css-extract-plugin
export default {"toastBox":"index_toastBox_8sI78","toast":"index_toast_zdOcN"};